module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('div', {
    staticClass: "breadcrumb-bar"
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": "/"
    }
  }, [_c('el-breadcrumb-item', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("首页")])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "fyd-body"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "msgBox"
  }, [_c('li', {
    staticStyle: {
      "margin-right": "10px"
    },
    on: {
      "click": _vm.borrow
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "flex2"
  }, [_c('el-button', {
    staticStyle: {
      "height": "40px",
      "width": "100px",
      "border-radius": "16px"
    },
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("领书")]), _vm._v(" "), _c('div', [_c('p', {
    staticStyle: {
      "float": "right",
      "font-size": "16px"
    }
  }, [_vm._v("已领取书籍")]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "font-size": "48px"
    }
  }, [_vm._v(_vm._s(_vm.pickBookCount))]), _vm._v("本")])])], 1)]), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.buycourse
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "flex2"
  }, [_c('el-button', {
    staticStyle: {
      "height": "40px",
      "width": "100px",
      "border-radius": "16px"
    },
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("了解详情")]), _vm._v(" "), _c('div', [_c('p', {
    staticStyle: {
      "float": "right",
      "font-size": "16px"
    }
  }, [_vm._v("已授权\n              "), _c('span', [_vm._v(_vm._s(_vm.authCourseCount) + "\n              ")]), _vm._v("\n                套课程")]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "font-size": "48px"
    }
  }, [_vm._v(_vm._s(_vm.authCourseCount))]), _vm._v("套")])])], 1)])]), _vm._v(" "), _c('ul', {
    staticClass: "operBox"
  }, [_c('li', {
    on: {
      "click": _vm.addTeacher
    }
  }, [_c('div', {
    staticClass: "flex"
  }, [_vm._m(2), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "48px"
    }
  }, [_vm._v(_vm._s(_vm.teacherCount))])]), _vm._v(" "), _c('p', [_vm._v("\n          教师作为本系统重要的管理员，利用本台，可以创\n          建所开设的课程和承担的教学班级，生成一个课程 教学环境。\n        ")])]), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.addStu
    }
  }, [_c('div', {
    staticClass: "flex"
  }, [_vm._m(3), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "48px"
    }
  }, [_vm._v(_vm._s(_vm.studentCount))])]), _vm._v(" "), _c('p', [_vm._v("学生用户是系统的主要用户，通常用户数非常多。")])]), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.addClass
    }
  }, [_c('div', {
    staticClass: "flex"
  }, [_vm._m(4), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "48px"
    }
  }, [_vm._v(_vm._s(_vm.classCount))])]), _vm._v(" "), _c('p', [_vm._v("课程班级信息的内容包括：班级信息及学生名单。")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex1"
  }, [_c('p', {
    staticStyle: {
      "font-size": "21px"
    }
  }, [_vm._v("公有库新增书籍")]), _vm._v(" "), _c('div', [_c('div', [_c('img', {
    attrs: {
      "src": "",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#20c9ac"
    }
  })]), _vm._v(" "), _c('p')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex1"
  }, [_c('p', {
    staticStyle: {
      "font-size": "21px"
    }
  }, [_vm._v("更多新增课程")]), _vm._v(" "), _c('div', [_c('div', [_c('img', {
    attrs: {
      "src": "",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#FC3400"
    }
  })]), _vm._v(" "), _c('p')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": require("../../assets/icon.png"),
      "alt": "",
      "width": "60px",
      "height": "60px"
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "21px"
    }
  }, [_vm._v("添加老师")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": require("../../assets/icon2.png"),
      "alt": "",
      "width": "60px",
      "height": "60px"
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "21px"
    }
  }, [_vm._v("添加学员")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": require("../../assets/icon1.png"),
      "alt": "",
      "width": "60px",
      "height": "60px"
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "21px"
    }
  }, [_vm._v("建立班级")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fe5e9406","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/book/index.vue
// module id = 736
// module chunks = 1